module.exports = __webpack_public_path__ + "media/common.6eff4a25.mp4";